{
  "Hello!": "Hej!",
  "Welcome to your learning hub.": "Välkommen till din lärportal!",
  "Get started with discovering content relevant to your role, interests, and personal development by setting up an account.": "Kom igång och upptäck innehåll som är relevant för dig.",
  "Our Terms & Conditions": "Våra villkor",
  "Before you can start on the platform, you must agree to our Terms of Use and Privacy Notes.": "Godkänn våra användarvillkor för att fortsätta. ",
  "You can request a copy of your data via the Privacy Notes page at any time.": "Du kan begära en kopia av din data på sidan Integritetspolicy.",
  "Be aware that you are now registering to a learning platform approved but not operated by LFAB": "Be aware that you are now registering to a learning platform approved but not operated by LFAB. The platform is approved for information up to confidentiality level K2 Restricted (K2 Begränsad).",
  "Terms of Use": "Användarvillkor",
  "I agree to": "Jag godkänner <0>{{terms}}</0>",
  "I understand": "Jag förstår",
  "Privacy Notes": "Integritetspolicy",
  "One more thing": "En sak till",
  "Before we begin": "Innan vi börjar",
  "extra-terms-generic": "Bifogat finner du även en fil från {{realm}} med viktig information. <0>Ladda ned och läs filen</0> för veta mer.",
  "extra-terms-kompetens": "Bifogat finner du även hur intygandet av tid går till när du genomfört ett lärande. <0>Ladda ned och läs filen</0> för veta mer.",
  "I have read it!": "Jag har läst!",
  "Create a profile": "Skapa en profil",
  "Let's go": "Sätt igång!",
  "New Terms of Use & Privacy Notes:": "Nya användarvillkor:",
  "First name": "Förnamn",
  "Last name": "Efternamn",
  "Something went wrong": "Ett fel uppstod"
}
